import React from 'react';
import ToastContext from './ToastContext';

class ToastProvider extends React.Component {
  constructor(props) {
    super(props);
    /* eslint-disable react/no-unused-state */

    this.nextKey = 0;
    this.unmounted = false;

    this.removeToast = toast => {
      if (this.unmounted) return;
      this.setState(({
        toasts
      }) => ({
        // eslint-disable-next-line react/no-unused-state
        toasts: toasts.filter(item => item !== toast)
      }));
    };

    this.notify = (level, message) => {
      const toast = {
        key: this.nextKey++,
        level,
        message,
        dismiss: () => {
          this.removeToast(toast);
        }
      };
      if (this.unmounted) return;
      this.setState(({
        toasts
      }) => ({
        // eslint-disable-next-line react/no-unused-state
        toasts: [...toasts, toast]
      }));
    };

    this.info = message => {
      this.notify('info', message);
    };

    this.success = message => {
      this.notify('success', message);
    };

    this.warning = message => {
      this.notify('warning', message);
    };

    this.error = message => {
      this.notify('error', message);
    };

    this.state = {
      toasts: [],
      notify: this.notify,
      info: this.info,
      success: this.success,
      warning: this.warning,
      error: this.error
    };
    /* eslint-enable react/no-unused-state */
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  render() {
    return React.createElement(ToastContext.Provider, {
      value: this.state
    }, this.props.children);
  }

}

export default ToastProvider;